import { Injectable, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { BASE_SITE_CONTEXT_ID, StatePersistenceService, StateWithProcess, StorageSyncType } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ProcessSelectors } from '../../process/store';
import { SiteContextParamsService } from '../../site-context';
import { PunchOutStatePersistenceFacade } from '../facades';
import { LoadPunchOutDataSuccess } from '../store/actions/punch-out-data-action';
import { PUNCHOUT_DATA_PROCESS } from '../store/user-state';

@Injectable()
export class PunchOutStatePersistenceService implements OnDestroy, PunchOutStatePersistenceFacade {
  protected subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private store: Store<StateWithProcess<any>>,
    private siteContextParamsService: SiteContextParamsService
  ) {}

  public initSync() {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'punchOut',
        state$: this.getPunchOutDataProcessState(),
        context$: this.siteContextParamsService.getValues([BASE_SITE_CONTEXT_ID]),
        storageType: StorageSyncType.SESSION_STORAGE,
        onRead: (state) => this.onRead(state),
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected getPunchOutDataProcessState(): Observable<any> {
    return this.store.pipe(
      select(ProcessSelectors.getProcessStateFactory(PUNCHOUT_DATA_PROCESS)),
      filter((state) => !!state),
      map((state) => state.value),
      distinctUntilChanged()
    );
  }

  protected onRead(state: any | undefined) {
    if (state) {
      this.store.dispatch(new LoadPunchOutDataSuccess(state));
    }
  }
}
